// import axios from 'axios';
import axiosIns from '@/utils/axios';

export function getAllModels() {
  return axiosIns.get('/admin/cmsmodel/list');
}

export function getDetail(modelName: string) {
  return axiosIns.get('/cms/entity/detail', { modelName });
}

export function getList(params: object) {
  return axiosIns.get('/cms/entity/list', { ...params });
}
export function getOptions(modelName: string) {
  return axiosIns.get('/admin/cms/entity/options', { modelName });
}

export function delEntity() {
  return axiosIns.post('/entity/del');
}
export function updateEntity() {
  return axiosIns.post('/entity/update');
}
export function updateStatusEntity() {
  return axiosIns.post('/entity/updatestatus');
}

export function getDict(params: object) {
  return axiosIns.get('/cms/dict/list', { ...params });
}
